import { render, staticRenderFns } from "./FollowerFormChanel.vue?vue&type=template&id=6c45294a&scoped=true&"
import script from "./FollowerFormChanel.vue?vue&type=script&lang=js&"
export * from "./FollowerFormChanel.vue?vue&type=script&lang=js&"
import style0 from "./FollowerFormChanel.vue?vue&type=style&index=0&id=6c45294a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c45294a",
  null
  
)

export default component.exports